export const FlowNodeColors = {
    boolean: '#880e4f',
    number: '#00BCD4',
    String: '#fff9c4',
    Long: '#ffcc80',
    Entity: '#b39ddb',
    Attribute: '#ffab91',
    fieldSelector: '#3F51B5',
    Column: '#f48fb1',
    Filter: '#e6ee9c',
    dataTableColumn: '#FF5722',
    result: '#607D8B',
    and: '#4caf50',
    or: '#009688',
    equals: '#2196f3',
    any: '#000',
    notEquals: '#880E4F',
};

export const FlowHandleStyle = {
    top: 53,
    width: 8,
    height: 8,
    background: FlowNodeColors.dataTableColumn
}

export const createHandleStyle = (top: number, background: string) => {
    return {
        ...FlowHandleStyle,
        top,
        background,
        border: 'solid 1px gray'
    }
}